// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.
export const custom = Symbol();
//# sourceMappingURL=inspect.common.js.map